/** The native Header owns the selected menu. Page sections consume its rendered path. */
class Breadcrumb extends HTMLElement {
  connectedCallback() {
    document.addEventListener('sc:breadcrumbs-change', this.#update);
    this.#update();
  }

  #update = () => {
    const template = document.querySelector('sc-breadcrumb-source template');
    if (template) this.replaceChildren(template.content.cloneNode(true));
  };

  disconnectedCallback() {
    document.removeEventListener('sc:breadcrumbs-change', this.#update);
  }
}

class BreadcrumbSource extends HTMLElement {
  #observer = new MutationObserver(() => this.#publish());

  connectedCallback() {
    this.#publish();
  }

  #publish() {
    this.#observer.disconnect();
    this.#observer.observe(this, { childList: true, characterData: true, subtree: true });
    const template = this.querySelector('template');
    if (template) this.#observer.observe(template.content, { childList: true, characterData: true, subtree: true });
    document.dispatchEvent(new Event('sc:breadcrumbs-change'));
  }

  disconnectedCallback() {
    this.#observer.disconnect();
  }
}

if (!customElements.get('sc-breadcrumb')) customElements.define('sc-breadcrumb', Breadcrumb);
if (!customElements.get('sc-breadcrumb-source')) customElements.define('sc-breadcrumb-source', BreadcrumbSource);
